<template>
	<b-container fluid>
		<b-row class="hide-print">
			<b-col cols="auto" class="mr-auto p-3">
				<b-button variant="outline-dark" @click="goBask" type="button">Назад</b-button>
			</b-col>
			<b-col cols="auto" class="p-3">
				<b-button v-on:click="print" variant="outline-dark" type="button"><i class="fa fa-print"></i>  Печать</b-button>
			</b-col>
		</b-row>
		<b-card>
			<b-row>
				<b-col align="center" style="font-size: 20px; font-weight: bold">
					{{ sale.shopShortName }} <span style="font-family: 'Franklin Gothic Medium'"></span>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b>Продажа №: </b> <span> {{sale.saleNumber}}</span><br>
					<b>Дата: </b> <span> {{sale.updateDate}}</span><br>
					<b>Сумма: </b> <span> {{sale.amountOfPaymentUzs | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'})}}</span><br>
					<b>Сумма со скидкой: </b> <span> {{sale.amountOfAfterPromoUzs | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'})}}</span>
				</b-col>
				<b-col>
					<strong>{{$t('xAtchot.cashier')}}: </strong> {{ sale.cashierFullName}}<br>
					<strong>Контрагент: </strong> {{ sale.contragentName }}
				</b-col>
				<b-col>
					<b-row>
						<b-col cols="4"><strong>Оплата: </strong></b-col>
						<b-col><span v-for="(val, index) in sale.payments" :key="index"><b>{{val.paymentTypeCode}} : </b> <span>{{val.value | currency({symbol: depCurrencyName, fractionCount: 2, symbolPosition: 'back'})}}</span><br></span></b-col>
					</b-row>
				</b-col>
			</b-row>
			<br>
			<table class="table-striped mt-1" style="width: 100%">
				<thead>
				<tr>
					<th class="border-table text-center">№</th>
					<th class="border-table text-left">Продукт</th>
					<th class="border-table text-center">Спец-код</th>
					<th class="border-table text-center">Штрих-код</th>
					<th class="border-table text-center">Количество</th>
					<th class="border-table text-center">Цена</th>
					<th class="border-table text-center">Сумма</th>
					<th class="border-table text-center">Цена со скидкой</th>
					<th class="border-table text-center">Сумма со скидкой</th>
					<th class="border-table text-center">Скидка</th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="(item, index) in sale.saleItems" :key="index" >
					<td class="border-table text-center">{{index+1}}</td>
					<td class="border-table text-left">{{item.name}}</td>
					<td class="border-table text-center">{{item.barcode}}</td>
					<td class="border-table text-center">{{item.multiBarcode.barcode}}</td>
					<td class="border-table text-center">{{item.count}}</td>
					<td class="border-table text-center">{{item.priceUzs | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'})}}</td>
					<td class="border-table text-center">{{(item.count*item.priceUzs) | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'})}}</td>
					<td class="border-table text-center">{{item.priceAfterUzs | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'})}}</td>
					<td class="border-table text-center">{{(item.priceAfterUzs * item.count) | currency({symbol: ' ', fractionCount: 2, symbolPosition: 'back'})}}</td>
					<td class="border-table text-center">{{item.customPromotion.discount + item.customPromotion.promotionType  }}</td>
				</tr>
				</tbody>
			</table>
		</b-card>
	</b-container>
</template>
<script>
import PosService from "@/services/pos.service";
export default {
	data() {
		return {
			sale: {}
		}
	},
	computed: {
		depCurrencyName() {
			return localStorage.getItem('dep_currency_code')
		}
	},
	methods: {
		async print() {
			window.print();
		},
		goBask() {
			this.$router.go(-1);
		}
	},
	created() {
		PosService.getSaleById(this.$route.params.id).then(res => {
			this.sale = res.data
		}).catch(e => {
			this.$vs.notify({
				title: e.message,
				color: 'danger',
				icon: 'close',
				position: 'top-right'
			});
		})
	}
}
</script>
<style>
	body {
		font-size: 16px;
	}
	.border-table {
		border: 2px solid black !important;
	}
	@media print {
		.hide-print {
			display: none;
		}
		.border-table {
			border: 2px solid black !important;
		}
	}
</style>
